import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model } from 'libx';
import Conversation from '../Conversation';
import { once } from 'lodash';
import { observable } from 'mobx';
export var RoomStatus = {
  Unknown: 'Unknown',
  Active: 'Active',
  Closed: 'Closed'
};

/**
 * @typedef {Object} WherebyRoomSource
 * @property {string} type
 *
 * @typedef {Object} LocalRoomSource
 * @property {string} type
 *
 * @typedef {WherebyRoomSource | LocalRoomSource} RoomSource
 */
export var Room = (_class = /*#__PURE__*/function (_Model) {
  function Room(conversation, primeMember) {
    var _this;
    _classCallCheck(this, Room);
    _this = _callSuper(this, Room);
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _this.dateCreated = new Date(0);
    _this.dateModified = new Date(0);
    _initializerDefineProperty(_this, "status", _descriptor2, _this);
    _initializerDefineProperty(_this, "roomSource", _descriptor3, _this);
    _this.conversation = conversation;
    return _this;
  }
  _inherits(Room, _Model);
  return _createClass(Room, [{
    key: "parse",
    value:
    /**
     *
     * @param {import('../API').RoomDTO} attrs
     * @returns {Room}
     * @private
     */
    function parse(attrs) {
      return {
        id: attrs.id,
        dateModified: attrs.date_modified,
        dateCreated: attrs.date_created,
        status: Room.mapRoomStatus(attrs.status),
        roomSource: Room.mapRoomSource(attrs.room_source)
      };
    }

    /**
     *
     * @param {string} status
     * @returns {RoomStatus}
     * @private
     */
  }], [{
    key: "none",
    get: function get() {
      return lazyNone();
    }
  }, {
    key: "mapRoomStatus",
    value: function mapRoomStatus(status) {
      switch (status) {
        case 'ACTIVE':
          return RoomStatus.Active;
        case 'CLOSED':
          return RoomStatus.Closed;
        default:
          return RoomStatus.Unknown;
      }
    }

    /**
     *
     * @param {import('../API').RoomSourceDTO} source
     * @returns {RoomSource}
     */
  }, {
    key: "mapRoomSource",
    value: function mapRoomSource(source) {
      switch (source === null || source === void 0 ? void 0 : source.type) {
        case 'Whereby':
          return {
            type: 'Whereby'
          };
        default:
          return {
            type: 'Local'
          };
      }
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "status", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return RoomStatus.Unknown;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "roomSource", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {
      type: 'Local'
    };
  }
}), _class);
var lazyNone = once(function () {
  return new Room(new Conversation());
});
//# sourceMappingURL=Room.js.map
